<template>
    <nav class="navbar is-transparent" :class="{'black': isBlack}" role="navigation" aria-label="main navigation" >
        <div class="container">
            <div class="navbar-brand">
                <router-link :to="{ name: 'Home' }">
                    <img v-if="isBlack" src="@/assets/img/logo-black.png" class="tallo-logo navbar-item"/>
                    <img v-else src="@/assets/img/logo.png" class="tallo-logo navbar-item"/>
                </router-link>

                <cart-menu class="cart-menu-burger is-hidden-desktop"></cart-menu>

                <template v-if="isAuthenticated">
                    <my-account-menu class="account-menu-burger is-hidden-desktop"></my-account-menu>
                </template>

                <div class="navbar-burger burger" style="margin-left: 0;" data-target="navbar-content" :class="{'is-active': navIsActive}" @click="toggleMenu">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

            <div id="navbar-content" class="navbar-menu" :class="{'is-active': navIsActive}">
                <div class="navbar-end">
                    <router-link class="navbar-item link" :to="{ name: 'About' }">Nosotros</router-link>
                    <router-link class="navbar-item link" :to="{ name: 'Products' }">Productos</router-link>
                    <router-link class="navbar-item link" :to="{ name: 'Help' }">Ayuda</router-link>

                    <template v-if="isAuthenticated">
                        <my-account-menu class="navbar-item is-hidden-touch"></my-account-menu>
                    </template>
                    <template v-else>
                        <router-link class="navbar-item link" :to="{ name: 'Login' }">Ingresar</router-link>
                        <router-link class="navbar-item link" :to="{ name: 'Register' }">Crear Cuenta</router-link>
                    </template>

                    <cart-menu class="navbar-item is-hidden-touch"></cart-menu>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    import CartMenu from './CartMenu';
    import MyAccountMenu from './MyAccountMenu';

    export default {
        name: 'TemplateNavBar',
        components: {
            CartMenu,
            MyAccountMenu
        },
        props: ['isBlack'],
        data() {
            return {
                navIsActive: false,
            }
        },

        computed: {
            isAuthenticated() {
                return this.$store.getters['user/isAuthenticated'];
            }
        },

        methods: {
            toggleMenu() {
                this.navIsActive = !this.navIsActive;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .cart-menu-burger {
        height: 3.25em;
        margin-top: auto;
        margin-bottom: auto;
        margin-left: auto;
    }

    .account-menu-burger {
        height: 3.25em;
        margin-top: auto;
        margin-bottom: auto;
        margin-left: 0;
    }

    .navbar {
        text-transform: uppercase;
        font-size: 1.0em;
        font-weight: 500;
        padding: 5px;

        .navbar-burger {
            background: none;
            color: white;

            margin-top: auto;
            margin-bottom: auto;

            span {
                height: 2px;
            }
        }

        .navbar-menu {
            .navbar-item {
                margin-right: 20px;
                letter-spacing: 0.1em;

                a:hover {
                    color: white;
                }

                &.link {
                    &::after {
                        content: "";
                        position: absolute;
                        width: 30px;
                        height: 3px;
                        top: 50px;
                        left: 13px;
                        border-bottom: 2px solid white;

                        -webkit-transition: all 0.2s; /* Safari */
                        transition: all 0.2s;
                    }

                    &:hover {
                        &::after {
                            width: 80%;
                        }
                    }

                    &.router-link-exact-active {
                        color: #8fbc1b;

                        &::after {
                            border-bottom: 2px solid #8fbc1b;
                        }
                    }
                }
            }

            .navbar-dropdown {
                a {
                    color: #4a4a4a;
                }
            }

            /* For styling links in mobile when burger menu is clicked */
            &.is-active {
                .navbar-item {
                    color: black;

                    &.link {
                        &::after {
                            display: none;
                        }
                    }
                }
            }
        }

        &.is-active {
            background-color: white;
            color: black;
        }

        &.black {
            background-color: white;
            box-shadow: 0 0 2px 1px rgba(0,0,0,0.1);
            transition: all 0.25s;
            color: black;

            .navbar-burger {
                color: black;
            }

            .navbar-menu {
                .navbar-item {
                    color: black;

                    &.link {
                        &::after {
                            border-bottom: 2px solid black;
                        }

                        &.router-link-exact-active {
                            color: #8fbc1b;

                            &::after {
                                border-bottom: 2px solid #8fbc1b;
                            }
                        }
                    }
                }

            }
        }
    }
</style>